import {
  queryWarrantyFeedback,
  getWarrantyFeedback,
  feedbackAudit,
  queryWarrantyDetail,
  exportWarrantyDetail,
  exportWarrantyFeedback
} from "@/graphql/warrantyCheck.gql";
import { filterNodeData } from "@root/lib/utils";
function expandArrayToMap(list) {
  const result = {};

  list.forEach(item => (result[item.value] = item.label));

  return result;
}

export default {
  namespaced: true,
  state: {
    dataList: [],
    detailData: {},
    detailList: []
  },
  getters: {
    FEEDBACK_STATUS(state, getters, rootState) {
      let data = rootState.root.ddCodes.FEEDBACK_STATUS || [];
      let result = expandArrayToMap(data);
      return result;
    },
    WARRANTY_STATUS(state, getters, rootState) {
      let data = rootState.root.ddCodes.WARRANTY_STATUS || [];
      let result = expandArrayToMap(data);
      return result;
    },
    FEEDBACK_IMAGE(state, getters, rootState) {
      let data = rootState.root.ddCodes.FEEDBACK_IMAGE || [];
      let result = expandArrayToMap(data);
      return result;
    },

    filterDatas(state, getters, rootState) {
      const { FEEDBACK_STATUS = {}, WARRANTY_STATUS = {} } = getters;
      //FEEDBACK_STATUS
      let data = state.dataList.map(
        ({
          effectiveBegin,
          effectiveEnd,
          warrantyStatus,
          feedbackStatus,
          ...othters
        }) => {
          return {
            ...othters,
            feedbackStatusStr: FEEDBACK_STATUS[feedbackStatus],
            warrantyStatusStr: WARRANTY_STATUS[warrantyStatus],
            effective: `${effectiveBegin}-${effectiveEnd}`
          };
        }
      );
      return data;
    }
  },
  actions: {
    async queryWarrantyFeedback({ rootState, commit }, data) {
      let {
        data: {
          res: {
            dataList = [],
            pageInfo: { totalCount: total }
          }
        }
      } = await rootState.gql.query({
        query: queryWarrantyFeedback,
        variables: data
      });
      commit("setDataList", dataList);
      return { total };
    },
    async queryDetail({ rootState, commit }, data) {
      let {
        data: { res }
      } = await rootState.gql.query({
        query: getWarrantyFeedback,
        variables: data
      });
      commit("setDetailData", res);
    },
    async check({ commit, state, rootState }: any, data: any) {
      let res = await rootState.gql.mutate({
        mutation: feedbackAudit,
        variables: {
          input: data
        }
      });
    },

    async exportWarrantyFeedback({ commit, state, rootState }: any, data: any) {
      await rootState.gql.query({
        query: exportWarrantyFeedback,
        variables: data
      });
    },

    ///// 质保明细页面接口
    //明细list
    //
    async queryWarrantyDetailList({ rootState, commit }, data) {
      let {
        data: {
          res: {
            dataList = [],
            pageInfo: { totalCount: total }
          }
        }
      } = await rootState.gql.query({
        query: queryWarrantyDetail,
        variables: data
      });
      commit("setDetailDataList", dataList);
      return { total };
    },
    async exportWarrantyDetail({ commit, state, rootState }: any, data: any) {
      await rootState.gql.query({
        query: exportWarrantyDetail,
        variables: data
      });
    }
  },
  mutations: {
    setDataList(state, data) {
      state.dataList = filterNodeData(data);
    },
    setDetailData(state, data) {
      state.detailData = data;
    },
    //明细list
    setDetailDataList(state, data) {
      state.detailList = filterNodeData(data);
    }
  }
};
